import React from "react";
import { IoMdHeartEmpty, IoMdHeart } from "react-icons/io";
import { useGetWishlist } from "../../Pregrine/Wishlist/useGetWishlist";
import { useAddToWishlist } from "../../Pregrine/Wishlist/useAddToWishlist";
import { useRemoveFromWishlist } from "../../Pregrine/Wishlist/useRemoveFromWishlist";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import classes from "./Wishlist.module.css";
import classNames from "classnames";

const GetWishlist = (props) => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const { item, itemId, text, btnClass, selectedOptionsArray } = props;
  const { wishlistData, wishlistId } = useGetWishlist();
  const wishlist = wishlistData.find((w) => w.product.id === itemId);

  const { addToast } = useToasts();

  let wishlistItem = {
    quantity: 1,
    sku: item.sku,
  };

  if (selectedOptionsArray?.length) {
    wishlistItem.selected_options = selectedOptionsArray;
  }

  const { addToWishlist } = useAddToWishlist({
    wishlistId,
    item: wishlistItem,
  });

  const { removeFromWishlist } = useRemoveFromWishlist({
    wishlistId,
    itemId: wishlist?.id,
  });

  const handleClick = () => {
    if (isSignedIn) {
      if (wishlist === undefined) {
        addToWishlist();
      } else {
        removeFromWishlist();
      }
    } else {
      addToast("Please sign-in to your Account to save items for later.", {
        appearance: "error",
        autoDismiss: true,
        style: {
          backgroundColor: "#DB1F00",
          color: "#fff",
        },
      });
    }
  };

  return (
    <div
      className={classNames(classes.wishlistIcon, {
        [classes.wishlist]: wishlist,
        [classes.unWishlist]: !wishlist,
        [classes.removeWishStyle]: text,
        [classes.wishWithText]: wishlist && text,
      })}
    >
      <button
        onClick={handleClick}
        className={classNames(btnClass, classes.defaultBtn)}
      >
        {wishlist ? <IoMdHeart /> : <IoMdHeartEmpty />}
        {text ? <span>Add to Wishlist</span> : null}
      </button>
    </div>
  );
};

export default GetWishlist;
